module.exports = __webpack_public_path__ + "static/media/blue_dragon.437f9d7d.png";